import { CloseCircle } from "iconsax-react-nativejs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Image, Linking, Pressable, Text, View } from "react-native";
import {
  PLAY_STORE_URL,
  dismissPlayBanner,
  isAndroidWeb,
  isPlayBannerDismissed,
} from "./play-banner.utils";

/**
 * Google Play prompt for Android mobile-web visitors. Never renders on native,
 * iOS or desktop. Dismissal is remembered per device in localStorage.
 * Decided after mount so the static web export never renders it server-side.
 */
const PlayStoreBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(isAndroidWeb() && !isPlayBannerDismissed());
  }, []);

  if (!visible) return null;

  const close = () => {
    dismissPlayBanner();
    setVisible(false);
  };

  return (
    <View
      testID="play-store-banner"
      className="flex-row items-center gap-3 border-b border-ash-3 bg-chalk px-3 py-2"
    >
      <Image
        source={require("@/src/assets/images/club_logo.png")}
        style={{ width: 36, height: 36, borderRadius: 10 }}
        alt=""
      />
      <View style={{ flex: 1, minWidth: 0 }} className="gap-0.5">
        <Text numberOfLines={1} className="font-medium text-sm text-onyx">
          {t("PLAY_BANNER_TITLE")}
        </Text>
        <Text numberOfLines={2} className="text-xs text-slate">
          {t("PLAY_BANNER_HINT")}
        </Text>
      </View>
      <Pressable
        testID="play-store-banner-cta"
        accessibilityRole="link"
        onPress={() => {
          void Linking.openURL(PLAY_STORE_URL);
        }}
        className="rounded-full bg-primary px-4 py-2 active:opacity-80"
      >
        <Text className="font-medium text-sm text-white">
          {t("PLAY_BANNER_CTA")}
        </Text>
      </Pressable>
      <Pressable
        testID="play-store-banner-dismiss"
        onPress={close}
        accessibilityLabel={t("PLAY_BANNER_DISMISS")}
        accessibilityRole="button"
        className="p-1 active:opacity-70"
      >
        <CloseCircle size={20} className="text-slate" />
      </Pressable>
    </View>
  );
};

export default PlayStoreBanner;
